import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Avatar, Box, Button, Divider, Drawer, IconButton, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { useLocation, Link, matchPath } from 'react-router-dom';
import { Scrollbar } from './scrollbar';
import { ChevronLeft as ChevronLeftIcon } from '../icons/chevron-left';
import { ChevronRight as ChevronRightIcon } from '../icons/chevron-right';
import GroupsIcon from '@mui/icons-material/Groups';
import BusinessIcon from '@mui/icons-material/Business';
import { useAuth } from '../hooks/use-auth';
import DescriptionIcon from '@mui/icons-material/Description';
import GridViewIcon from '@mui/icons-material/GridView';
import RuleIcon from '@mui/icons-material/Rule';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AccountCircleIcon from '@mui/icons-material/AccountCircle'; // Example icon, you can use any other icon you prefer

import "../Custom.css"
import { ProjectIdContext } from '../contexts/Project/Project';
const items = [
  {
    icon: GroupsIcon,
    title: 'Pages',
    href: '/dashboard/pages',
  },
  {
    icon: BusinessIcon,
    title: 'Images',
    href: '/dashboard/images',
  },
  {
    icon: GridViewIcon,
    title: 'Directories',
    href: '/dashboard/directories',
  },
  {
    icon: DescriptionIcon,
    title: 'Errors',
    href: '/dashboard/errors',
  },
  // {
  //   icon: RuleIcon,
  //   title: 'Attendance',
  //   href: '/dashboard/attendance',
  // },
  // {
  //   icon: CalendarMonthIcon,
  //   title: 'Holiday Calendar',
  //   href: '/dashboard/holidaycalendar',
  // },
];

export const DashboardSidebar = (props) => {
  const { onPin, pinned } = props;
  const { pathname } = useLocation();

  const [activeItem, setActiveItem] = useState(null);
  const auth = useAuth();
  const location = useLocation();

  const { ProjectID, setProjectID, setProjectName } = ProjectIdContext()

  useEffect(() => {
    items.forEach((item) => {
      const active = !!matchPath({ path: item.href, end: true }, pathname);
      if (active) {
        setActiveItem(item);
      }
    });
  }, [pathname]);
  const logoutHandler = () => {
    auth.logout();
    setProjectID()
    setProjectName()
    localStorage.clear()
  };

  return (
    <Drawer
      open
      sx={{ zIndex: 1000 }}
      variant="permanent"
      PaperProps={{
        onMouseOver: () => { },
        onMouseLeave: () => { },
        sx: {
          backgroundColor: 'background.paper',
          height: '100%',
          overflowX: 'hidden',
          transition: 'width 250ms ease-in-out',
          width: pinned ? 230 : 73,
          '& .simplebar-content': {
            height: '100%',
          },
          '&:hover': {
            width: 230,
            '& span, p': {
              display: 'flex',
            },
          },
        },
      }}
    >
      <div style={{ display: 'inline-flex', alignItems: 'center', marginTop: 20, paddingLeft: 15 }}>
        <Avatar sx={{ backgroundColor: 'rgb(42,196,171)', color: 'white', width: '26px', height: '26px' }}>CR</Avatar>
        <Typography variant="body1" style={{ marginLeft: 5, fontWeight: 600, fontSize: 15 }}>CRAWLER</Typography>
      </div>
      <Divider sx={{ color: 'gray', mt: "18px" }} />
      <Scrollbar
        style={{
          display: 'flex',
          flex: 1,
          overflowX: 'hidden',
          overflowY: 'auto',
        }}
      >

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            p: 2,
            pt: 3,
          }}
        >
          <div className="logout">
            <Button onClick={logoutHandler}>Logout</Button>
          </div>
          <List disablePadding>
            {items.map((item) => (

              <Link to={item.href}

                style={{
                  textDecoration: 'none',
                  color: 'rgb(133,150,160)',
                  justifyContent: 'flex-start',
                  whiteSpace: 'nowrap',
                }}>
                <ListItem sx={{
                  backgroundColor: activeItem?.title === item.title ? 'rgb(234,248,244)' : '', borderRadius: 2
                }}>
                  <ListItemIcon className="custom-list-icon">
                    <item.icon
                      className='dash-icons'
                      sx={{
                        color: activeItem?.title === item.title ? 'rgb(77,122,210)' : 'rgb(111,132,143)',
                      }}
                    />
                  </ListItemIcon>

                  <ListItemText>
                    <Typography style={{
                      fontWeight: 500, fontSize: '14px',
                      color: activeItem?.title === item.title ? 'rgb(77,122,210)' : 'rgb(103,123,133)'
                    }}>{item.title}</Typography>
                  </ListItemText>
                </ListItem>
              </Link>

            ))}
          </List>
        </Box>
      </Scrollbar>
      <Box sx={{ pt: 2 }}>
        <IconButton onClick={onPin}>
          {pinned ? <ChevronLeftIcon /> : <ChevronRightIcon />}
        </IconButton>
      </Box>
    </Drawer >
  );
};

DashboardSidebar.propTypes = {
  onPin: PropTypes.func,
  pinned: PropTypes.bool,
};
